import type { LoginSchema, PartialUser } from '@/validators/auth'
import { apiClient } from '@/api/base'
import { useMutation } from '@tanstack/react-query'

interface LoginMutationRes {
  user: PartialUser
  accessToken: string
}
export function useLoginMutation() {
  return useMutation({
    mutationKey: ['login'],
    mutationFn: async (credentials: LoginSchema) => {
      const res = await apiClient('/api/auth/login', { method: 'POST', data: credentials, requireAuth: false })
      return res.data as LoginMutationRes
    },
  })
}
